import React, { Component } from 'react';
import './App.css';
import animation from './animation'

const SIZE = 0.85
const slides = [
	{
		type: 'page',
		f: 'p-compania-1.jpg',
		w: 1907,
		h: 7061
	},
	{
		type: 'detail',
		f: 'zona-comp-noastra-1.jpg',
		w: 1903,
		h: 880
	},
	{
		type: 'page',
		f: 'p-servicii-1.jpg',
		w: 1906,
		h: 3832
	},
	{
		type: 'detail',
		f: 'zona-dir-adj-1.jpg',
		w: 1906,
		h: 1166,
		pause: true
	},
	{
		type: 'page',
		f: 'p-viziune-1.jpg',
		w: 1906,
		h: 3765
	},
	{
		type: 'detail',
		f: 'zona-constr-ind-1.jpg',
		w: 1906,
		h: 1287,
		pause: true
	},
	{
		type: 'page',
		f: 'pstructura-1.jpg',
		w: 1906,
		h: 3858
	},
	{
		type: 'detail',
		f: 'zona-dir-1.jpg',
		w: 1906,
		h: 1494,
		pause: true
	},
	{
		type: 'page',
		f: 'zona-logistica-3.jpg',
		w: 1903,
		h: 2999
	},
	{
		type: 'detail',
		f: 'zona-proiecte-1.jpg',
		w: 1903,
		h: 1207
	},
]

const mq = (W) => {
        if (W <= 400) return 'xss'
        if (W <= 600) return 'xs'
        if (W <= 900) return 'sm'
        if (W <= 1200) return 'md'
        if (W <= 1600) return 'lg'
        return 'xl'
}

const getScreen = () => {
	const W = window.innerWidth
    const H = window.innerHeight
    const screen = {W, H}
	screen.MQ = mq(screen.W)
	screen.O = screen.W > screen.H ? 'landscape' : 'portrait'
	screen.isPortrait = screen.O==='portrait'
    screen.isMobile = screen.W < 400 || screen.H < 400
    screen.MOBILE = screen.isMobile?'mobile':''
    screen.ASPECT = screen.W / screen.H
    return screen
}
class App extends Component {
	constructor(props) {
		super(props)
		this.state = this.getState()
	}
	
	componentDidMount() {
		window.addEventListener('resize', this.onResize)
		//this.setState({on: true})
		//setTimeout(() => {animation.run(this.state, slides)}, 5000)
		animation.run(this.state, slides)
	}
	
	onResize = () => {
		this.setState(this.getState())
	}
	
	getState = () => {
		const screen = getScreen()
		return Object.assign({}, {screen}, this.resizeTablet(screen))
	}
	
	resizeTablet = (screen) => {
		const img = screen.isPortrait
			?'/img/tableta/tableta-p-2.png'
			:'/img/tableta/tableta-ld-2.png'
		const aspect = 	screen.isPortrait
			?(1414/983)
			:(983/1414)
		
		let w = screen.W * SIZE
		let h = w*aspect
		if (h>screen.H*SIZE) {
			h = screen.H*SIZE
			w = h / aspect
		}
		
		const tabletStyle = {
			backgroundImage: `url(${img})`,
			width: `${w}px`,
			height: `${h}px`
		}
		
		let top, left;
		if (screen.isPortrait) {
			top = h * 0.13
			left = w * 0.10
			w = w * 0.8
			h = h * 0.74
		} else {
			top = h * 0.10
			left = w * 0.13
			w = w * 0.74
			h = h * 0.8
		}
		const tabletScreenStyle = {
			top: `${top}px`,
			left: `${left}px`,
			width: `${w}px`,
			height: `${h}px`
		}
		return {
			tabletStyle,
			tabletScreenStyle,
			tabletW: w,
			tabletH: h
		}
	}
	render() {
		const {tabletStyle, tabletScreenStyle} = this.state

    	return (
    		<div id='app'>
    			<div className='video'>
				<video autoPlay playsInline muted loop id="video-bg">
					<source src="/img/fireworks2.mp4" type="video/mp4"/>
				</video>
    			</div>
				<div className='video-after'/>
				<div className='presentation'>
					<div className='tablet' style={tabletStyle}>
						<div className='tablet-screen' style={tabletScreenStyle}>
							<div className='tablet-slideshow'>
								{slides.map((s,i) => 
									<div key={i} className={`tablet-slide slide-${i} slide-${s.type}`}><img src={`/img/pagini/${s.f}`} alt=''/></div>
								)}
							</div>
        				</div>
					</div>
        		</div>
        		<div className='logotop'><img id='logotop' src='/img/sgn-indemanarea-white.svg' alt='logo'/></div>
        		<div className='logo'><img id='logo' src='/img/logo-aniversar-red-white-gray-sh-2.svg' alt='logo'/></div>
        		<div className='happy'><div>
        			<div className='line1'>La mulți ani!</div>
        			<div className='line2'>Celebrăm un sfert de secol</div>
        			<div className='line3'>Ne vedem în curând!</div>
        			<div className='line1'>La mulți ani!</div>
        			<div className='line2'>Celebrăm un sfert de secol</div>
        			<div className='line3'>Ne vedem în curând!</div>
        		</div></div>
        	</div>
    	)
	}
}

export default App;
/*
				*/


// WEBPACK FOOTER //
// ./src/App.js